import React from 'react'
import { Facebook, Twitter, Linkedin, Link as LinkIcon, Mail } from 'lucide-react'
import toast from 'react-hot-toast'

const SocialShare = ({ url, title, description }) => {
  const shareUrl = url || window.location.href
  const shareTitle = title || document.title
  const shareDescription = description || ''

  const handleShare = (platform) => {
    let shareLink = ''
    
    switch(platform) {
      case 'facebook':
        shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
        break
      case 'twitter':
        shareLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`
        break
      case 'linkedin':
        shareLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`
        break
      case 'email':
        shareLink = `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareDescription + '\n\n' + shareUrl)}`
        break
      case 'copy':
        navigator.clipboard.writeText(shareUrl)
        toast.success('Link copied to clipboard!')
        return
      default:
        return
    }
    
    if (shareLink) {
      window.open(shareLink, '_blank', 'width=600,height=400')
    }
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-600 font-medium">Share:</span>
      <div className="flex gap-2">
        <button
          onClick={() => handleShare('facebook')}
          className="w-8 h-8 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center transition-colors"
          title="Share on Facebook"
        >
          <Facebook className="w-4 h-4 text-white" />
        </button>
        <button
          onClick={() => handleShare('twitter')}
          className="w-8 h-8 bg-sky-500 hover:bg-sky-600 rounded-full flex items-center justify-center transition-colors"
          title="Share on Twitter"
        >
          <Twitter className="w-4 h-4 text-white" />
        </button>
        <button
          onClick={() => handleShare('linkedin')}
          className="w-8 h-8 bg-blue-700 hover:bg-blue-800 rounded-full flex items-center justify-center transition-colors"
          title="Share on LinkedIn"
        >
          <Linkedin className="w-4 h-4 text-white" />
        </button>
        <button
          onClick={() => handleShare('email')}
          className="w-8 h-8 bg-gray-600 hover:bg-gray-700 rounded-full flex items-center justify-center transition-colors"
          title="Share via Email"
        >
          <Mail className="w-4 h-4 text-white" />
        </button>
        <button
          onClick={() => handleShare('copy')}
          className="w-8 h-8 bg-gray-500 hover:bg-gray-600 rounded-full flex items-center justify-center transition-colors"
          title="Copy Link"
        >
          <LinkIcon className="w-4 h-4 text-white" />
        </button>
      </div>
    </div>
  )
}

export default SocialShare